module.exports = __webpack_public_path__ + "img/wz-8-1-4.e1a60a82.jpg";